export const ONE_TIME_PAYMENT_STATUS_CREATED = 'CREATED'
export const ONE_TIME_PAYMENT_STATUS_PAID = 'PAID'
export const ONE_TIME_PAYMENT_STATUS_CANCELLED = 'CANCELLED'